module.exports = __webpack_public_path__ + "img/V19.fbaddf8e.jpg";